import { Box, Drawer } from "@material-ui/core"
import classNames from "classnames"
import React, { useState } from "react"
import { useStyles } from "./historico-pedidos-modal-styles"
import { EnumModals, useModalStore } from "services/store/modal-store"
import { HistoricoPedidosHeader } from "./components/historico-pedidos-header/historico-pedidos-header"
import { HistoricoPedidosList } from "./components/historico-pedidos-list/historico-pedidos-list"
import { HistoricoPedidosError } from "./components/historico-pedidos-error/historico-pedidos-error"
import { HistoricoPedidoContent } from "./components/historico-pedido-content/historico-pedido-content"
import { useObterToken } from "services/store/obter-token"

export const HistoricoPedidosModal = () => {
    const classes = useStyles()
    const { modals } = useModalStore(state => state)
    const modal = modals[EnumModals.HistoricoPedidos]
    const [pedidoId, setPedidoId] = useState<string>('')
    const { rotaValida } = useObterToken(state => state)
    const contaLogada = rotaValida()

    const voltar = pedidoId ? () => setPedidoId('') : undefined

    return (
        <Drawer
            variant={"temporary"}
            anchor={"right"}
            open={modal.aberto}
            classes={{ paper: classNames(classes.drawer) }}
            style={{
                overflowX: 'hidden',
                position: 'relative'
            }}
        >
            {modal.aberto && (
                <>
                    <HistoricoPedidosHeader voltar={voltar} />
                    {!contaLogada ? (
                        <HistoricoPedidosError
                            textPrimary="Para visualizar o histórico de pedidos,"
                            textSecondary="você deve primeiro entrar na sua conta."
                            isLogin={true}
                        />
                    ) : (
                        <Box display="block" height="100%">
                            {pedidoId ? (
                                <HistoricoPedidoContent pedidoId={pedidoId} />
                            ) : (
                                <HistoricoPedidosList onClick={setPedidoId} />
                            )}
                        </Box>
                    )}
                </>
            )}
        </Drawer>
    )
}